import React, { useState, useEffect } from 'react';
import { Container, Grid, FormControlLabel, Button } from '@material-ui/core';
import { CustomeAlert } from 'Components/Alert/Alert';
import {
    LOGOUT,
    AGENT_SELECT_LIST,
    AGENT_DELETE,
    AGENT_ACTIVATE,
    AGENT_SETASUSER
} from 'ConstComponents';
import Switch from '@material-ui/core/Switch';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Backdrop from '@material-ui/core/Backdrop';
import Loader from 'Components/Loader/Loader';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router';
import ReactTable from 'Components/ReactTable/ReactTable';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

export const Agent = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [agents, setAgents] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});

    const onClick = item => {
        var RequestObj = { AgentID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const activate = async (item, value) => {
        var jsonObj = {
            AgentID: item,
            IsActive: value
        };
        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoadingOpen(true);

        const response = await AGENT_ACTIVATE(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) setSeverity('error');

        setIsError(true);
        selectAgent();
    };

    const setAsUser = async (item, value) => {
        var jsonObj = {
            AgentID: item,
            IsActive: value
        };
        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoadingOpen(true);

        const response = await AGENT_SETASUSER(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (response.status === false) {
            setSeverity('error');
            return;
        }

        selectAgent();
    };

    const selectAgent = async () => {
        setLoadingOpen(true);
        const response = await AGENT_SELECT_LIST();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        var data = JSON.parse(response.data);
        setAgents(data);
    };

    useEffect(() => {
        selectAgent();
        createColumns();
    }, []);

    const DeleteAgent = async request => {
        setIsError(false);
        setLoadingOpen(true);
        var jsonReq = JSON.stringify(request);

        const response = await AGENT_DELETE(jsonReq);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) setSeverity('error');

        setIsError(true);
        selectAgent();
    };
    const EditUser = async request => {
        history.push('/Agent/Edit/' + request);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'AgentID',
            srno: true
        });

        columns.push({
            label: 'AgentName',
            name: 'AgentName'
        });
        columns.push({
            label: 'Mobile',
            name: 'AgentMobile'
        });
        columns.push({
            label: 'Address',
            name: 'AgentAddress'
        });
        columns.push({
            label: 'Pan No',
            name: 'AgentPanNumber'
        });

        columns.push({
            label: 'DOJ',
            name: 'AgentDOJ'
        });

        columns.push({
            label: 'Active',
            name: 'IsActive',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const agentID = tableMeta.rowData[0];
                    return (
                        <FormControlLabel
                            value={value ? 'Yes' : 'No'}
                            control={
                                <Switch
                                    color="primary"
                                    checked={value}
                                    value={value ? 'Yes' : 'No'}
                                />
                            }
                            onChange={event => {
                                var newValue =
                                    event.target.value === 'Yes' ? false : true;
                                updateValue(newValue);
                                activate(agentID, newValue);
                            }}
                        />
                    );
                }
            }
        });

        columns.push({
            label: 'SetAsUser',
            name: 'IsUser',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const agentID = tableMeta.rowData[0];
                    return (
                        <FormControlLabel
                            value={value ? 'Yes' : 'No'}
                            control={
                                <Switch
                                    color="primary"
                                    checked={value}
                                    value={value ? 'Yes' : 'No'}
                                />
                            }
                            onChange={event => {
                                var newValue =
                                    event.target.value === 'Yes' ? false : true;
                                updateValue(newValue);
                                setAsUser(agentID, newValue);
                            }}
                        />
                    );
                }
            }
        });

        columns.push({
            label: 'Edit',
            name: 'AgentID',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <EditIcon
                            variant="contained"
                            color="primary"
                            onClick={event => {
                                EditUser(value);
                            }}
                        />
                    );
                }
            }
        });

        columns.push({
            label: 'Delete ',
            name: 'AgentID',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <DeleteIcon
                            color="secondary"
                            variant="contained"
                            onClick={event => {
                                onClick(value);
                            }}
                        />
                    );
                }
            }
        });

        setMainColumns(columns);
    };

    return (
        <>
            {isError ? (
                <CustomeAlert
                    isOpen={isError}
                    message={responseMessage}
                    severity={severity}
                    onCloseCallback={alertState => {
                        setIsError(alertState);
                    }}
                />
            ) : null}

            {isAlertOpen ? (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this agent."
                    request={confirmAlertRequest}
                    positiveButtonClick={request => {
                        setIsAlertOpen(false);
                        DeleteAgent(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            <Backdrop className={classes.backdrop} open={loadingOpen}>
                <Loader />
            </Backdrop>
            <Grid style={{ marginBottom: '5px', marginTop: '5px' }}>
                <Box display="flex" flexDirection="row-reverse">
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.CustomPrimaryButtonStyle}
                        href="/Agent/Add"
                    >
                        New Agent
                    </Button>
                </Box>
            </Grid>

            <ReactTable List={agents} columns={mainColumns} />
        </>
    );
};
